import { useRouteMatch } from 'react-router-dom';

export const TENANT_PREFIX = {
  CONTRACTOR: '/contractor',
  MOBIS: '/mobis',
};

export const isContractorPath = (pathname: string) =>
  pathname.startsWith(TENANT_PREFIX.CONTRACTOR);

export const isMobisPath = (pathname: string) =>
  pathname.startsWith(TENANT_PREFIX.MOBIS);

export const isInternalPath = (pathname: string) => {
  return !isMobisPath(pathname) && !isContractorPath(pathname);
};

const getTenantPrefixFromPath = (pathname: string): string => {
  if (isContractorPath(pathname)) {
    return TENANT_PREFIX.CONTRACTOR;
  }
  if (isMobisPath(pathname)) {
    return TENANT_PREFIX.MOBIS;
  }
  return '';
};

export const getTenantBasepath = (): string => {
  return getTenantPrefixFromPath(window.location.pathname);
};

export const useTenantBasepath = () => {
  const { url } = useRouteMatch();
  return getTenantPrefixFromPath(url);
};
